import feathersClient from '../../feathers-client';

const defaultPersonaListPagination = {
	total: 100,
	$skip: 0,
	$limit: 10,
};

const defaultPersonaListPaginationFilter = {
	$skip: defaultPersonaListPagination.$skip,
	$limit: defaultPersonaListPagination.$limit,
};


export default {
    state: {
        capComSkills: [],
        personaList:[],
        personaPagination:defaultPersonaListPagination,
        personaPaginationFilter:defaultPersonaListPaginationFilter,
        personaType:null,
        personaSelectedRole:{},

    },
    getters: {
        capComSkills: (state) => state.capComSkills,
        personaPage:(state) => {
            const { $limit, $skip } = state.personaPagination;
			return $skip / $limit + 1;
        },
        getPersonaSummeryData:(state) => {
            const { personaType, personaSelectedRole} = state
            return { personaType, personaSelectedRole}
        }
    },
    mutations: {
        SET_CAP_COM_SKILLS: (state, data) => {
            state.capComSkills = data;
        },
        SET_PERSONA_LIST:(state,data) => {state.personaList = data;},
		SET_PERSONA_LIST_PAGINATION:(state, data) => {state.personaPagination = {...state.personaPagination, ...data};},
		SET_PERSONA_LIST_PAGINATION_FILTER: (state, filter) => { state.personaPaginationFilter = { ...state.personaPaginationFilter, ...filter }; },
		SET_DEFAULT_PERSONA_LIST_FILTER: (state, filter) => { state.personaPaginationFilter = { ...filter, ...defaultPersonaListPaginationFilter }; },
        SET_PERSONA_SUMMERY_DATA: (state, payload) => {
           
				state.personaType = payload?.personaType || '';
			state.personaSelectedRole = payload?.personaSelectedRole || {};
		},
       
    },
    actions: {
        setDefaultPersonaListFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_PERSONA_LIST_FILTER', filter);
		},
        setPersonaListFilter: ({ commit }, filter) => {
			commit('SET_PERSONA_LIST_PAGINATION_FILTER', filter);
		},
		setPersonaListPage:({commit,state},page) =>{
			const $skip = (page - 1) * state.personaPagination.$limit;
			commit('SET_PERSONA_LIST_PAGINATION', { $skip });
			commit('SET_PERSONA_LIST_PAGINATION_FILTER', { $skip });
		},
        getNeoSKills: async ({ commit},searchText) => {
            let result = await feathersClient.service('api/v3/custom-shift-templates').find({
                query: {
                    $searchSkills: true,
                    text: searchText,
                },
            });
            commit('SET_CAP_COM_SKILLS', result);
			return result;
        },
        getAllTrustRoleType: async({ rootGetters, commit, rootState }, filter) => {
            const results = await feathersClient.service('api/v3/job-title-types').find({
                query: {
                    // $role: rootGetters.currentUserRole,
                    // trustId: rootState?.organizationStore?.currentTrustId,
                    // fields: ['jobTitleType'],
                    $paginate:false,
                    ...filter,
                },
            });
            const filteredResult = results?.map(item => {
                if(item?.jobTitleType){
                    return item?.jobTitleType
                }
            })
            return results;
        },
        getPersonasForTrust:async({rootGetters, commit, rootState},filter) => {
            const result = await feathersClient.service('api/v3/personas').find({
                query:{
                    $role: rootGetters.currentUserRole,
                    fields:['roles','trust','selectedRole'],
                    ...filter
                }
            })
            commit('SET_PERSONA_LIST',result?.data)
			commit('SET_PERSONA_LIST_PAGINATION', {total :result?.total})
            return result?.data
        },
        getCapabilitiesBasedOnRole : async ({rootGetters,rootState},filter) => {
            const result = await feathersClient.service('api/v3/capability').find({
                query:{
                    $role: rootGetters.currentUserRole,
                    ...filter,
                }
            })
            return result
        },
        getCapabilitiesBasedOnSearch : async ({rootGetters,rootState},filter) => {
            const result = await feathersClient.service('api/v3/neo-search').find({
                query:{
                    $role: rootGetters.currentUserRole,
                    ...filter,
                }
            })
            return result
        },
        createPersonas:async ({rootGetters,rootState},data) => {
            // data.trustId = rootState?.organizationStore?.currentTrustId
            const result = await feathersClient.service('api/v3/personas').create(data,{
                query:{
                    $role: rootGetters.currentUserRole,
                }
            });
            return result
        },
        createCapability:async({rootGetters,rootState}, data) => {
            const result = await feathersClient.service('api/v3/capability').create(data,{
                query:{
                    $role: rootGetters.currentUserRole,
                }
            });
            return result
        },
        createCompetency:async ({rootGetters,rootState},data) => {
            const result = await feathersClient.service('api/v3/competency').create(data,{
                query:{
                    $role: rootGetters.currentUserRole,
                }
            });
            return result
        },
        createNeoSkill:async ({rootGetters,rootState},data) => {
            const result = await feathersClient.service('api/v3/neo-skills').create(data,{
                query:{
                    $role: rootGetters.currentUserRole,
                }
            });
            return result
        },
        getPersonaById: async({rootGetters},id) => {
            const result = await feathersClient.service('api/v3/personas').get(id,{
                query:{
                    $role: rootGetters.currentUserRole,
                    fields:['roles','selectedRole']
                }
            })
            return result 
        },
        updatePersona: async({rootGetters},data) => {
            const id= data.id
            delete data.id
            const result = await feathersClient.service('api/v3/personas').patch(id,data,{
                query:{
                    $role: rootGetters.currentUserRole,
                }
            })
            return result 
        },
        deletePersona: async({rootGetters},id) => {
            const result = await feathersClient.service('api/v3/personas').remove(id,{
                query:{
                    $role: rootGetters.currentUserRole,
                }
            })
            return result 
        },
        loadTrustForPersonFilter: async({ commit, rootGetters }) => {
			const url = '/api/v3/trusts';
			const results = await feathersClient.service(url).find({
				query: {
                    isLive:true,
                    isTrainingTrust:false,
					$paginate: false,
				},
			});
			return results;
		},
        deleteNode:async({rootGetters},data) => {
            const id = data.nodeId
            const type = data.type
            const url = `/api/v3/${type}`
            const results = await feathersClient.service(url).remove(id,{
                query:{
                    $role: rootGetters.currentUserRole,
                } 
            })
            return results 
        },
        editNode:async({rootGetters},data) => {
            const id = data.nodeId
            const type = data.type
            delete data.nodeId
            delete data.type
            const url = `/api/v3/${type}`
            const results = await feathersClient.service(url).patch(id, data,{
                query:{
                    $role: rootGetters.currentUserRole,
                } 
            })
            return results 
        },
    },    
}